import React, { useState, useEffect  } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import HomePage from './Pages/HomePage';
import DashboardAdmin from './Pages/DashboardAdmin';
import DashboardGuest from './Pages/DashboardGuest';
import DashboardBohol from './Pages/DashboardBohol';
import DashboardNoso from './Pages/DashboardNoso';
import DashboardSiquijor from './Pages/DashboardSiquijor';
import LoginModal from './Components/Login2';
import CISTemplate from './Admin/cisTemplate'; // Add this import
import ConvergenceTemplate from './Admin/convergenceTemplate'; // Siguroa nga naa ni nga import
import NISTemplate from './Admin/nisTemplate';


import GlobalStyle from './Components/GlobalStyle'; 
import './App.css'; 

const App = () => {
  const [darkMode, setDarkMode] = useState(false);

  useEffect(() => {

    if (darkMode) {
      document.body.classList.add('dark-mode');
    } else {
      document.body.classList.remove('dark-mode');
    }
  }, [darkMode]);

  
  const toggleDarkMode = () => {
    setDarkMode((prevMode) => !prevMode);
  };

  return (
    <Router>
    <GlobalStyle darkMode={darkMode} /> 

    <div>
       

    <Routes>
      
    <Route path="/*" element={<HomePage />} />
      
    <Route path="DashboardAdmin" element={<DashboardAdmin darkMode={darkMode} toggleDarkMode={toggleDarkMode} />} />

    <Route path="DashboardGuest" element={<DashboardGuest />} />
    <Route path="DashboardBohol" element={<DashboardBohol />} />
     <Route path="DashboardNoso" element={<DashboardNoso />} />
      <Route path="DashboardSiquijor" element={<DashboardSiquijor />} />

    <Route path="/Login" element={<LoginModal />} />
    <Route path="/convergenceTemplate" element={<ConvergenceTemplate />} /> {/* Siguroa nga naa ni */}
    <Route path="/cisTemplate" element={<CISTemplate />} />
    <Route path="/nisTemplate" element={<NISTemplate />} />
    </Routes>


    </div>
    </Router>
  );
};
export default App;